import { render } from "./SiteButton.vue?vue&type=template&id=7ce8b2a3&scoped=true"
import script from "./SiteButton.vue?vue&type=script&lang=js"
export * from "./SiteButton.vue?vue&type=script&lang=js"

import "./SiteButton.vue?vue&type=style&index=0&id=7ce8b2a3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce8b2a3"]])

export default __exports__